import React from 'react'
import '../../css/header.css';
import styles from '../../css/headerServices.module.css'
import image from '../../assest/header/9889a6af2e15b9cd7fa0cf51f36c75993e41f7fa.png'
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import   data  from '../../data/data.js'
import MetaHelmet from './MetaHelmet.jsx';
function HeaderServices() {
    let index = -1;
    const location = useLocation();
    switch (location.pathname) {
        case '/services/TrainQualif':
            index = 0;
            break;
        case '/services/medicalservices':
            index = 1;
            break;
        case '/services/saberservices':
            index = 2;
            break;
        case '/services/najizServices':
            index = 3;
            break;
        case '/services/madad':
            index = 4;
            break;
        case '/services':
            index = 5;
            break;
        case '/services/professionallicense':
            index = 6;
            break;
        case '/services/agriculturallicense':
            index = 7;
            break;
        case '/services/forecommlice':
            index = 8;
            break;
        case '/services/coiLissauPar':
            index = 9;
            break;
        case '/services/proflicesapartner':
            index = 10;
            break;
        case '/services/transactivlice':
            index = 11;
            break;
        case '/services/prolic':
            index = 12;
            break;
        case '/services/indlic':
            index = 13;
            break;
        case '/services/invbizres':
            index = 14;
            break;
        case '/services/unires':
            index = 15;
            break;
        case '/services/entres':
            index = 16;
            break;
        case '/services/proownres':
            index = 17;
            break;
        case '/services/talres':
            index = 18;
            break;
        case '/services/excepres':
            index = 19;
            break;
        case '/services/manorgevCon':
            index = 20;
            break;
        case '/services/actTabtam':
            index = 21;
            break;
        case '/services/devweb':
            index = 22;
            break;
        case '/services/upmap':
            index = 23;
            break;
        case '/services/raibra':
            index = 24;
            break;
        case '/services/manorgEst':
            index = 25;
            break;
        case '/services/mansocacc':
            index = 26;
            break;
        case '/services/propho':
            index = 27;
            break;
        case '/services/booAccrec':
            index = 28;
            break;
        case '/services/settraacc':
            index = 29;
            break;
        case '/services/accsysper':
            index = 30;
            break;
        case '/services/warinvman':
            index = 31;
            break;
        case '/services/proacccon':
            index = 32;
            break;
        case '/services/proaccsys':
            index = 33;
            break;
        case '/services/pretaxdec':
            index = 34;
            break;
        case '/services/prefinadmfin':
            index = 35;
            break;
        case '/services/civilservices':
            index = 36;
            break; 
        case '/services/appDev':
            index = 37;
            break; 
        case '/services/web':
            index = 38;
            break; 
        case '/services/technicSupport':
            index = 39;
            break; 
        case '/services/accountSys':
            index = 40;
            break; 
        case '/services/hr':
            index = 41;
            break; 
        case '/services/AdminSystem':
            index = 42;
            break; 
        case '/services/crm':
            index = 43;
            break; 
        case '/services/trademarks':
        index = 44;
        break
        case '/services/patent':
        index = 45;
        break;
        case '/services/indusproduct':
        index = 46;
        break;
        case '/services/copyright':
        index = 47;
        break;
    }

    return (
        <>
            <MetaHelmet title={data[index].page} keywords={data[index].keywords} description={data[index].description}/>
            <div>
                <div className={styles.container}>
                    <div className={styles.partImage}>
                        <img loading='lazy' src={index !== -1 ? data[index].path : image} alt="Background" />
                    </div>
                    <div style={{ position: 'absolute', top: '32%', right: '10%',borderBottom:'2px solid'}}>
                        <p>
                            <Link to='/' style={{fontSize: '20px', fontWeight: 'bold'}}>الرئيسية / </Link>
                            {index !== -1 ? data[index].page : ''}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderServices